import React , {useState} from 'react'
import {styled , Grid , Typography} from "@mui/material"
import   MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import MailIcon from "@mui/icons-material/Mail";
import ScreenLoader from '../../shared/ScreenLoader';
import NoItemSelected from '../../shared/NoItemSelected';

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props}  />
  ))(({theme}) => ({
    marginTop:"5px !important",
    "&:before": {
      display: "none",
  
    },
  }));

  const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
    expandIcon={<ArrowRightIcon sx={{ fontSize: "1.8rem" }} />}
      {...props}
    />
  ))(({theme}) => ({
    boxSizing: "border-box",
    height: "34px",
    minHeight: "34px",
    backgroundColor: "#fff",
    flexDirection: "row-reverse",
    paddingRight:theme.spacing(0),
    paddingLeft:theme.spacing(0),
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
      transform: "rotate(270deg)",
    },
    "& .MuiAccordionSummary-expandIconWrapper": {
      transform: "rotate(90deg)",
      color: "#50566E",
      fontSize: ".875rem",
      fontWeight: "600",
    },
    "& .MuiAccordionSummary-content": {
      color: "#50566E",
      fontSize: ".875rem",
      fontWeight: "550",
      lineheight: "16px",
    },
  }));

  const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(0),
    paddingLeft: theme.spacing(0),
    borderTop: "1px solid rgba(0, 0, 0, .125)",
  }));
  
  const CustomTypography = styled((props) => <Typography {...props} />)(() => ({
    color: "#050D2E",
    fontSize: ".875rem",
    fontWeight: "bold",
    lineheight: "16px",
  }));
  
const MatchingView = ({orginalMessagePart1, orginalMessagePart2}) => {
  const [expanded, setExpanded] = useState("part1");
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const [expanded2, setExpanded2] = useState("part2");
  const handleChange2 = (panel) => (event, newExpanded) => {
    setExpanded2(newExpanded ? panel : false);
  };
   
  return (
<>
{orginalMessagePart1 || orginalMessagePart2 ?  
<div>
   
{orginalMessagePart1 &&  
<Accordion
         aria-controls="panel1a-content"
         id="panel1a-header"
         expanded={expanded === 'part1'}
         onChange={handleChange('part1')}
         >     
         <AccordionSummary 
              expandIcon={<ArrowRightIcon sx={{ fontSize: "1.8rem" }} />}
  >
               <Grid
                 container
                 alignItems="center"
                 justifyContent="space-between"
                 sx={{ width: "100%" }}
               >
                 <Grid item>
                   <Grid container alignItems="center">
                     <Grid item>
                     <MailIcon
                         sx={{ fontSize: "1.1rem", paddingTop: "5px" , verticalAlign: "inherit" , color:"#50566E" }}
                       />
                     </Grid>
                     <Grid item sx={{ marginLeft: "5px" }}>
                       <CustomTypography>Message part 1</CustomTypography>
                     </Grid>
                   </Grid>
                 </Grid>
               </Grid>
          </AccordionSummary>
          <AccordionDetails>
                {orginalMessagePart1}
 
          </AccordionDetails>
      
      </Accordion> }


      {orginalMessagePart2 &&  
<Accordion
         aria-controls="panel2a-content"
         id="panel2a-header"
         expanded={expanded2 === 'part2'}
         onChange={handleChange2('part2')}
         >     
         <AccordionSummary 
              expandIcon={<ArrowRightIcon sx={{ fontSize: "1.8rem" }} />}
  >
               <Grid
                 container
                 alignItems="center"
                 justifyContent="space-between"
                 sx={{ width: "100%" }}
               >
                 <Grid item>
                   <Grid container alignItems="center">
                     <Grid item>
                     <MailIcon
                         sx={{ fontSize: "1.1rem", paddingTop: "5px" , verticalAlign: "inherit" , color:"#50566E" }}
                       />
                     </Grid>
                     <Grid item sx={{ marginLeft: "5px" }}>
                       <CustomTypography>Message part 2</CustomTypography>
                     </Grid>
                   </Grid>
                 </Grid>
               </Grid>
          </AccordionSummary>
          <AccordionDetails>
                {orginalMessagePart2}
 
          </AccordionDetails>
      
      </Accordion> }
   
     </div> : <NoItemSelected/>}
</>
  )
}

export default MatchingView